<template>
    <div class="login-container">
        <div class="login-form">
            <div class="header">
                <h1>DALOUNNY CLOSET</h1>
            </div>
            <div class="divider"></div>
            <form class="form" @submit.prevent="login">
                <b-field class="form-input">
                    <b-input
                        v-model="email"
                        expanded
                        placeholder="ອີເມວ"
                        icon="email-outline"
                        required
                        validation-message="ກະລຸນາປ້ອນອີເມວ"
                        ref="emailInput"
                        type="email"
                    ></b-input>
                </b-field>
                <b-field class="form-input">
                    <b-input
                        v-model="password"
                        expanded
                        placeholder="ລະຫັດຜ່ານ"
                        icon="lock-outline"
                        required
                        validation-message="ກະລຸນາປ້ອນລະຫັດຜ່ານ"
                        type="password"
                    ></b-input>
                </b-field>
                <div>
                    <b-button
                        native-type="submit"
                        expanded
                        type="is-primary"
                        class="form-button"
                        :loading="isLogginIn"
                    >ເຂົ້າລະບົບ</b-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {auth} from '../firebase';

    export default {
        name: "Login",
        data () {
            return {
                isLogginIn: false,
                email: null,
                password: null,
            }
        },
        methods: {
            login() {
                this.isLogginIn = !this.isLogginIn
                auth.signInWithEmailAndPassword(this.email, this.password).then(res => {
                    console.log(res);
                    this.isLogginIn = !this.isLogginIn
                    this.$store.set("userData", {
                        email: res.user.email,
                        emailVerified: res.user.emailVerified,
                        isAnonymous: res.user.isAnonymous,
                        displayName: res.user.displayName,
                        phoneNumber: res.user.phoneNumber,
                        photoURL: res.user.photoURL,
                        token: res.user.refreshToken,
                        lastSignInTime: res.user.metadata.lastSignInTime,
                    });
                    this.$router.replace('/dashboard');
                }).catch(err => {
                    console.log(err);
                    this.isLogginIn = !this.isLogginIn
                    this.$swal('', err.message, 'error');
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .login-container{
        display: flex;
        justify-content: center;
        align-items: center;
        height: calc(100vh - 60px);
    }
    .login-form {
        background-color: #fff;
        padding: 50px;
        border-radius: 12px;
        width: 450px;
        box-shadow: 0 2px 5px #ccc;
        .header{
            display: flex;
            justify-content: center;
            color: #78909c;
            h1{
                font-size: 18pt;
                font-weight: bold;
            }
        }
        .divider{
            margin: 12px auto;
            height: 4px;
            width: 99px;
            border-radius: 2px;
            background: #f48fb1;
        }
        .form {
            margin-top: 30px;
        }
        .form-input{
            margin: 25px 0;
        }
        .form-button {
            margin-top: 30px;
            border-radius: 30px;
        }
    }
</style>